// extracted by mini-css-extract-plugin
module.exports = {"root":"EventInnerPageDesktop_root__KRy4J","column":"EventInnerPageDesktop_column__PVcAx"};